import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNavigation.css';

export const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="bottom-navigation">
      <button 
        className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}
        onClick={() => navigate('/dashboard')}
      >
        <i className="fas fa-home"></i>
        <span>Home</span>
      </button>
      
      <button 
        className={`nav-item ${isActive('/transactions') ? 'active' : ''}`}
        onClick={() => navigate('/transactions')}
      >
        <i className="fas fa-history"></i>
        <span>History</span>
      </button>
      
      <button 
        className="scan-button"
        onClick={() => navigate('/send-money')}
      >
        <i className="fas fa-qrcode"></i>
      </button>
      
      <button 
        className={`nav-item ${isActive('/orders') ? 'active' : ''}`}
        onClick={() => navigate('/orders')}
      >
        <i className="fas fa-shopping-cart"></i>
        <span>Orders</span>
      </button>
      
      <button 
        className={`nav-item ${isActive('/profile') ? 'active' : ''}`}
        onClick={() => navigate('/profile')}
      >
        <i className="fas fa-user"></i>
        <span>Profile</span>
      </button>
    </div>
  );
};